export const config = {
  // apiUrl: "http://192.168.0.136:1337",
  apiUrl: "https://strapi-staging-7edyny5ppq-ew.a.run.app",
  itineraryUrl: "https://itinerary-calculator-staging-7edyny5ppq-ew.a.run.app",
  directionsApiUrl: "https://maps.googleapis.com/maps/api/directions/json",
  googleMapsApiKey: "AIzaSyBFuFdr5kEK-H1uYgryi0d3lR0VOuVTW2U",
};
